<template>
    <div>
        <p class="mb-6">
            Desde aquí se edita el contenido que ven los alumnos en la portada,
            en la página del proceso de práctica y en las preguntas frecuentes,
            los contactos que aparecen en ellas y en los correos, y los modos
            de práctica que se ofrecen al inscribir.
        </p>

        <v-row>
            <v-col cols="12" md="6" lg="4">
                <v-card class="pa-5 fill-height d-flex flex-column">
                    <v-row align="center" class="flex-grow-0">
                        <v-avatar class="ma-1" color="primary">
                            <v-icon class="ma-3 white--text">mdi-youtube</v-icon>
                        </v-avatar>
                        <v-col>
                            <h5 class="mb-0 font-weight-bold">
                                Editar video y presentación de informaciones
                            </h5>
                            <p class="mb-0 font-italic">
                                El video y la presentación de la charla que se
                                muestran en el panel de informaciones.
                            </p>
                        </v-col>
                    </v-row>
                    <v-card-actions class="mt-4 pa-0 flex-wrap">
                        <v-btn
                            elevation="0"
                            color="primary"
                            class="mb-2 mr-2"
                            @click="modalVideo = true"
                        >
                            Editar video
                        </v-btn>
                        <v-btn
                            elevation="0"
                            color="primary"
                            class="mb-2"
                            @click="modalPresentacion = true"
                        >
                            Editar presentación
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <v-card class="pa-5 fill-height d-flex flex-column">
                    <v-row align="center" class="flex-grow-0">
                        <v-avatar class="ma-1" color="primary">
                            <v-icon class="ma-3 white--text">mdi-text-box-edit</v-icon>
                        </v-avatar>
                        <v-col>
                            <h5 class="mb-0 font-weight-bold">
                                Información del proceso
                            </h5>
                            <p class="mb-0 font-italic">
                                Las secciones que explican el proceso de práctica.
                            </p>
                        </v-col>
                    </v-row>
                    <v-card-actions class="mt-4 pa-0">
                        <v-btn
                            elevation="0"
                            color="primary"
                            @click="$router.push('/configuracion/info_proceso')"
                        >
                            Configurar secciones
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <v-card class="pa-5 fill-height d-flex flex-column">
                    <v-row align="center" class="flex-grow-0">
                        <v-avatar class="ma-1" color="primary">
                            <v-icon class="ma-3 white--text">mdi-frequently-asked-questions</v-icon>
                        </v-avatar>
                        <v-col>
                            <h5 class="mb-0 font-weight-bold">
                                Preguntas frecuentes
                            </h5>
                            <p class="mb-0 font-italic">
                                Las secciones y las preguntas, con sus respuestas.
                            </p>
                        </v-col>
                    </v-row>
                    <v-card-actions class="mt-4 pa-0">
                        <v-btn
                            elevation="0"
                            color="primary"
                            @click="$router.push('/configuracion/preguntas_frecuentes')"
                        >
                            Configurar preguntas
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <v-card class="pa-5 fill-height d-flex flex-column">
                    <v-row align="center" class="flex-grow-0">
                        <v-avatar class="ma-1" color="primary">
                            <v-icon class="ma-3 white--text">mdi-account-group</v-icon>
                        </v-avatar>
                        <v-col>
                            <h5 class="mb-0 font-weight-bold">
                                Representantes
                            </h5>
                            <p class="mb-0 font-italic">
                                Personas que aparecerán como contacto y a cargo
                                del sistema de prácticas.
                            </p>
                        </v-col>
                    </v-row>
                    <v-card-actions class="mt-4 pa-0">
                        <v-btn
                            elevation="0"
                            color="primary"
                            @click="$router.push('/configuracion/representantes')"
                        >
                            Editar representantes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <v-card class="pa-5 fill-height d-flex flex-column">
                    <v-row align="center" class="flex-grow-0">
                        <v-avatar class="ma-1" color="primary">
                            <v-icon class="ma-3 white--text">mdi-calendar-clock</v-icon>
                        </v-avatar>
                        <v-col>
                            <h5 class="mb-0 font-weight-bold">
                                Modos de práctica
                            </h5>
                            <p class="mb-0 font-italic">
                                Las modalidades que el alumno elige al inscribir
                                su práctica, con sus horas.
                            </p>
                        </v-col>
                    </v-row>
                    <v-card-actions class="mt-4 pa-0">
                        <v-btn
                            elevation="0"
                            color="primary"
                            @click="$router.push('/configuracion/modos')"
                        >
                            Configurar modos
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <ModalVideo
            :active="modalVideo"
            @cerrar="modalVideo = false"
        />

        <ModalPresentacion
            :active="modalPresentacion"
            @cerrar="modalPresentacion = false"
        />
    </div>
</template>

<script>
import ModalVideo from "./ModalVideo";
import ModalPresentacion from "./ModalPresentacion";

export default {
    components: { ModalVideo, ModalPresentacion },

    data: () => ({
        modalVideo: false,
        modalPresentacion: false,
    }),
};
</script>
